import { apiService } from './index';

// Inport types
import { ISelectType } from '../shared/types/select-type';

export const asyncGetRequestTypes = async (): Promise<ISelectType[]> => {
    const { items }: any = await apiService.get(`/api/request-type`);
    return items || [];
};

export const asyncGetRequestTypeByCode = async (
    code: string
): Promise<ISelectType> => {
    const { items }: any = await apiService.get(
        `/api/request-type/by-code/${code}`
    );
    return items;
};
